import { fade } from '@material-ui/core/styles';
import config from '../../config';

export const appHeaderStyles = (theme) => ({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    maxHeight: config.headerHeight,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: 46.75,
  },
  logoLink: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginRight: 10,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 10,
  },
  appBarShift: {
    marginLeft: config.drawerWidth,
    width: `calc(100% - ${config.drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButtonWrapper: {
    width: 56,
    color: 'black',
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  search: {
    position: 'relative',
    display: 'flex',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
    height: 40,
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  autoRefresh: {
    marginRight: 0,
    whiteSpace: 'nowrap',
  },
  selectInputsWrapper: {
    width: '100%',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
  },
  selectInputsWrapperDrpDown: {
    width: '50%',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    marginRight:3
  },
  dataRefreshWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  dataRefreshTop: {
    display: 'flex',
    alignItems: 'center',
    height: 30,
  },
  updateTime: {
    margin: 0,
  },
});
